import { useEffect, useState } from 'react';

export default function useWindowWidth() {
  const [pageWidth, setPageWidth] = useState(window.innerWidth);

  useEffect(() => {
    function storePageWidth() {
      setPageWidth(window.innerWidth);
    }
    // innerWidth includes the scrollbar like CSS media queries do, which a
    // ResizeObserver's content box doesn't
    // eslint-disable-next-line unicorn/prefer-observer-apis
    window.addEventListener('resize', storePageWidth);
    return () => {
      window.removeEventListener('resize', storePageWidth);
    };
  }, []);

  return pageWidth;
}
